import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/brand.css";

const ITEMS_PER_PAGE = 9;
const MIN_PAGES = 5;

const blogs = [
    // ✅ NEW BLOG ALWAYS FIRST
  { id: 4, image: "/assets/c_4.png", title: " Building Workplaces People Choose HR Voices by Outstanding Workplaces", path: "/building-workplaces" },
  { id: 1, image: "/assets/c_1.png", title: "Where Values Drive Engagement and Growth",path: "/drive-management"  },
  { id: 2, image: "/assets/c_2.png", title: "Showcasing What Makes Your Workplace Irresistible",path: "/show-casing"  },
  { id: 3, image: "/assets/c_3.png", title: "Talent Acquisition That Reflects Our Culture and Values",path: "/talent-acquisition"  },
];

const categories = [
  { label: "All Blogs", path: "/blogs" },
  { label: "Workplace Best Practices", path: "/work" },
  { label: "Employee Engagement", path: "/Engagement" },
  { label: "Employee Branding", path: "/Brand"},
  { label: "Thought Leadership & Workplace Culture", path: "/Thought" },
];

const getPageWindow = (current, total) => {
  const windowSize = 1;
  let start = Math.max(1, current - Math.floor(windowSize / 2));
  let end = start + windowSize - 1;
  if (end > total) {
    end = total;
    start = Math.max(1, end - windowSize + 1);
  }
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};

const CustomDropdown = ({ selected, setSelected, onNavigate }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="brand-dropdown">
      <div className="brand-dropdown__header" onClick={() => setOpen(!open)}>
        <span>{selected}</span>
        <span className={`brand-dropdown__arrow ${open ? "open" : ""}`}>
          <img src="/assets/arrow_1.png" alt="arrow" />
        </span>
      </div>

      {open && (
        <div className="brand-dropdown__list">
          {categories.map((item, index) => (
            <div
              key={index}
              className="brand-dropdown__item"
              onClick={() => {
                setSelected(item.label);
                setOpen(false);
                onNavigate(item.path);
              }}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const BlogPage = () => {
  const navigate = useNavigate();

  const handleCardClick = (path) => {
    if (path) {
      navigate(path);
    }
  };
  const [selectedCategory, setSelectedCategory] = useState("Employee Branding");
  const [currentPage, setCurrentPage] = useState(1);

  const realTotalPages = Math.ceil(blogs.length / ITEMS_PER_PAGE);
  const totalPages = Math.max(realTotalPages, MIN_PAGES);

  const handlePageChange = (n) => {
    if (n < 1 || n > totalPages) return;
    setCurrentPage(n);
  };

  const pageBlogs = blogs.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const pageWindow = getPageWindow(currentPage, totalPages);

  return (
    <div className="brand">
      <div className="brand__header">
        <h2 className="brand__title-main">Employee Branding</h2>
        <CustomDropdown
          selected={selectedCategory}
          setSelected={(label) => {
            setSelectedCategory(label);
            setCurrentPage(1);
          }}
          onNavigate={(path) => navigate(path)}
        />
      </div>

      <div className="brand__grid">
        {pageBlogs.length > 0 ? (
          pageBlogs.map((blog) => (
            <div
  className="brand-card"
  key={blog.id}
  onClick={() => handleCardClick(blog.path)}
  style={{ cursor: "pointer" }}
>
              <div className="brand-card__image-wrapper">
                <img src={blog.image} alt="" className="brand-card__image" />
              </div>
              <p className="brand-card__title">{blog.title}</p>
            </div>
          ))
        ) : (
          <p className="brand__no-results">No blogs found.</p>
        )}
      </div>

      <div className="brand-pagination">
        <button
          className="brand-pagination__btn"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          ← Previous
        </button>

        <div className="brand-pagination__numbers">
          {pageWindow.map((n) => {
            const isDisabled = n > realTotalPages;
            return (
              <span
                key={n}
                className={`brand-pagination__number 
                  ${n === currentPage ? "brand-pagination__number--active" : ""}
                  ${isDisabled ? "brand-pagination__number--disabled" : ""}
                `}
                onClick={() => !isDisabled && handlePageChange(n)}
              >
                {n}
              </span>
            );
          })}
        </div>

        <button
          className="brand-pagination__btn"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === realTotalPages}
        >
          Next →
        </button>
      </div>
    </div>
  );
};

export default BlogPage;